import { useState } from 'react'
import { uniqueId } from 'lodash-es'

export default function useId(prefix: string) {
  const [_uniqueId] = useState<string>(() => uniqueId(prefix))

  return _uniqueId
}
